import { ResourceHelperService } from "../resource-helper.service";

/**
 * A class that contains methods for interacting with the product request service
 */
export class ProductSettlementRequestService {
  private productSettlementRequests: InterACT.Interfaces.IResource<InterACT.Interfaces.ProductSettlement.ProductSettlementRequestsResponse>;

  constructor(private $resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.productSettlementRequests = $resource('api/product-settlement-requests/:requestId');
  }

  /**
   * A method that creates a product settlement request for the supplied scheme and periods
   * @param schemeLink the link for the scheme for create the settlement request for
   * @param settlementPeriod the settlement preiods to request to settle
   */
  public create(schemeLink: InterACT.Interfaces.Users.SchemeLink, settlementPeriod: InterACT.Interfaces.ProductSettlement.ProductSettlementPeriodLink) {
    const settlementRequest: InterACT.Interfaces.ProductSettlement.ProductSettlementRequest = {
      scheme: schemeLink,
      period: settlementPeriod
    };

    return this.productSettlementRequests.save(settlementRequest).$promise;
  }
}